export default __webpack_public_path__ + "static/media/chevron-down.fb28d088.svg";